import Player from '@vimeo/player';

const initialiseVideoPlayer = () => {
    const vimeoPlayers = document.querySelectorAll('[data-video-player]') as NodeListOf<HTMLIFrameElement>;

    for (let i = 0; i < vimeoPlayers.length; i++) {
        const ele = vimeoPlayers[i];
        if(!ele) continue;

        const player = new Player(ele, {
            autoplay: true,
            muted: true,
        });

        player.setVolume(0);

    }
}

export default initialiseVideoPlayer;